export enum eSalesTaxSubTypes {
  title_fee_extended_lenders_policy = 'title_fee_extended_lenders_policy',
  title_fee_homeowners_policy = 'title_fee_homeowners_policy',
  title_fee_lenders = 'title_fee_lenders_policy',
  title_fee_owners = 'title_fee_owners_policy',
  title_fee_settlement = 'title_fee_settlement',
}
